
import React from "react";
import { useNavigate } from "react-router-dom";
import Profile from "../pages/common/Profile";
import LogoutModal from "../pages/common/LogoutModal";
import UserManagement from "../pages/common/UserManagement";
import { useState } from "react";

const Sidebar = ({ userRole, projectId, scenario, isProjectSelection }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false);
  // 使用React Router的导航钩子
  const navigate = useNavigate();

  // 从localStorage获取用户角色
  const storedRole = localStorage.getItem('userRole');
  // 使用props传入的role或localStorage中的role
  const currentRole = userRole || storedRole;

  // 定义不同角色的权限
  const rolePermissions = {
    admin: ["project", "monitor", "drawing", "contact", "home"],    // 管理员权限
    office: ["project", "monitor", "drawing", "contact", "home"],   // 办公室人员权限
    pm: ["project", "monitor", "drawing", "contact", "home"],       // 项目经理权限
    consultant: ["project", "home"],                     // 顾问权限
    site: ["monitor", "contact", "home"],                          // 现场人员权限
    marketing: ["project", "home"],                      // 市场营销权限
  };

  // 检查用户是否有访问特定功能的权限
  const hasAccess = (item) => rolePermissions[userRole]?.includes(item);

  // 判断是否为营销场景
  const isMarketing = scenario === "marketing";

  return (
    // 侧边栏容器
    <div className="fixed left-0 top-0 h-screen w-[60px] bg-[#1e354a] pt-5 flex flex-col items-center z-50 overflow-hidden">
      {/* 主页图标 */}
      {hasAccess("home") && (
        <div className="relative w-full">
          <div
            className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
            onClick={() => navigate("/app_home")}
          >
            <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-6 h-6 text-white">
              <path
                fill="currentColor"
                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
              />
            </svg>
            <p className="text-white text-xs mt-1">Home</p>
          </div>
        </div>
      )}

      {/* 项目图标 */}
      {hasAccess("project") && (
        <div className="relative w-full">
          <div
            className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
            onClick={() => {
              const type = scenario || "construction";
              navigate(`/select_project?type=${type}`);
            }}
          >
            <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" className="w-6 h-6 text-white">
              <path
                fill="currentColor"
                d="M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
              />
            </svg>
            <p className="text-white text-xs mt-1">Project</p>
          </div>
        </div>
      )}

      {/* 营销场景特有功能 */}
      {scenario === "marketing" && !isProjectSelection && (
        <>
          {/* 日程表按钮 */}
          <div className="relative w-full">
            <div
              className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
              onClick={() => navigate("/marketing_page")}
            >
              <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-6 h-6 text-white">
                <path
                  fill="currentColor"
                  d="M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48C0 85.5 21.5 64 48 64h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192z"
                />
              </svg>
              <p className="text-white text-xs mt-1">Schedule</p>
            </div>
          </div>

          {/* 文件夹按钮 */}
          <div className="relative w-full">
            <div
              className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
              onClick={() => navigate("/marketing_folder")}
            >
              <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-6 h-6 text-white">
                <path
                  fill="currentColor"
                  d="M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
                />
              </svg>
              <p className="text-white text-xs mt-1">Folder</p>
            </div>
          </div>
        </>
      )}

      {/* 施工场景特有功能 */}
      {scenario === "construction" && hasAccess("monitor") && !isProjectSelection && (
        <>
          {/* 施工进度表按钮 */}
          <div className="relative w-full">
            <div
              className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
              onClick={() => navigate(`/construction_page/${projectId}`)}
            >
              <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-6 h-6 text-white">
                <path
                  fill="currentColor"
                  d="M128 0c17.7 0 32 14.3 32 32v32h128V32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48c26.5 0 48 21.5 48 48v48H0v-48C0 85.5 21.5 64 48 64h48V32c0-17.7 14.3-32 32-32zM0 192h448v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192z"
                />
              </svg>
              <p className="text-white text-xs mt-1">Schedule</p>
            </div>
          </div>

          {/* 监控按钮 */}
          <div className="relative w-full">
            <div
              className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
              onClick={() => navigate(`/monitor/${projectId}`)}
            >
              <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" className="w-6 h-6 text-white">
                <path
                  fill="currentColor"
                  d="M64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h176l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32h-69.3L336 416h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm448 64v224H64V64h448z"
                />
              </svg>
              <p className="text-white text-xs mt-1">Monitor</p>
            </div>
          </div>

          {/* 图纸按钮 */}
          {hasAccess("drawing") && (
            <div className="relative w-full">
              <div
                className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
                onClick={() => navigate("/construction_files_folder")}
              >
                <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-6 h-6 text-white">
                  <path
                    fill="currentColor"
                    d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                  />
                  <path
                    fill="currentColor"
                    d="M14 17H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
                  />
                </svg>
                <p className="text-white text-xs mt-1">Drawing</p>
              </div>
            </div>
          )}

          {/* 联系人按钮 */}
          {hasAccess("contact") && (
            <div className="relative w-full">
              <div
                className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
                onClick={() => navigate(`/contacts/${projectId}`)}
              >
                <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" className="w-6 h-6 text-white">
                  <path
                    fill="currentColor"
                    d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l0-8c0-60.9 49.1-110 110-110l29.7 0c32.1-58.2 94.6-98 167.2-98c40.9 0 77.9 15.6 105.9 41.2c-7.5-1.6-15.2-2.6-23.2-2.6c-77.4 0-140 62.6-140 140 0 24.9 6.5 48.3 17.9 68.6c-2.3-5.4-3.6-11.3-3.6-17.6c0-26.5 21.5-48 48-48l97.5 0c7.1 0 13.9 1.2 20.2 3.4c-9.6-18.8-22.4-35.7-37.8-49.4l48.7-48.7c40.1 35.9 65.6 88.3 65.6 146.6c0 70.7-57.3 128-128 128L609.3 512z"
                  />
                </svg>
                <p className="text-white text-xs mt-1">Contact</p>
              </div>
            </div>
          )}
        </>
      )}

      {/* 计划模块文件夹 */}
      {scenario === "plan" && projectId && (
        <div className="relative w-full">
          <div
            className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
            onClick={() => navigate("/planfile_page")}
          >
            <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-6 h-6 text-white">
              <path
                fill="currentColor"
                d="M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
              />
            </svg>
            <p className="text-white text-xs mt-1">Folders</p>
          </div>
        </div>
      )}

      {/* 底部图标区域 - 只在app_home页面显示 */}
      {window.location.pathname === "/app_home" && (
        <div className="mt-auto pb-5 flex flex-col items-center">
          {/* Profile图标 - 所有用户可见 */}
          <div className="relative w-full">
            <div 
              className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
              onClick={() => setIsProfileOpen(true)}
            >
              <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-6 h-6 text-white">
                <path fill="currentColor" d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"/>
              </svg>
              <p className="text-white text-xs mt-1">Profile</p>
            </div>
          </div>

          {/* User图标 - 仅管理员可见 */}
          {currentRole === "admin" && (
            <div className="relative w-full">
              <div 
                className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
                onClick={() => setIsUserManagementOpen(true)}
              >
                <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" className="w-6 h-6 text-white">
                  <path fill="currentColor" d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"/>
                </svg>
                <p className="text-white text-xs mt-1">Users</p>
              </div>
            </div>
          )}

          {/* Logout图标 - 所有用户可见 */}
          <div className="relative w-full">
            <div 
              className="p-4 w-full cursor-pointer flex flex-col items-center transition-colors group"
              onClick={() => setIsLogoutModalOpen(true)}
            >
              <span className="absolute left-0 top-2 bottom-2 w-1 rounded bg-white opacity-0 group-hover:opacity-100 transition-all"></span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-6 h-6 text-white">
                <path fill="currentColor" d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"/>
              </svg>
              <p className="text-white text-xs mt-1">Logout</p>
            </div>
          </div>
        </div>
      )}
      
      {/* 无论在哪个页面，都保持模态框的挂载，这样它们仍然可以在需要时打开 */}
      <Profile isOpen={isProfileOpen} onClose={() => setIsProfileOpen(false)} />
      <LogoutModal isOpen={isLogoutModalOpen} onClose={() => setIsLogoutModalOpen(false)} />
      <UserManagement isOpen={isUserManagementOpen} onClose={() => setIsUserManagementOpen(false)} />
    </div>
  );
};

export default Sidebar;
